// 任务中心-》异步任务列表

import { HttpTaskAsyncList } from '@/service/tasks';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                labelWidth: 90,
            },
        };
    },
    methods: {
        ajaxRequest: HttpTaskAsyncList,
    },
    computed: {
        // ...mapGetters('dictionary', ['getSysorgList']),
        // 模块
        getModuleList() {
            return [
                { value: 1, label: "计费单" },
                { value: 20, label: "仓库作业费明细" },
                { value: 25, label: "包材费用明细" },
                { value: 30, label: "增值服务费明细" },
                { value: 40, label: "配送费明细" },
                { value: 50, label: "堆存费明细/仓储费" },
                { value: 60, label: "承运商服务分区费率管理" },
                { value: 70, label: "FEDEX账单导入" },
                { value: 80, label: "账单管理" },
                { value: 90, label: "快递包裹结算" },
                { value: 91, label: "FEDEX新账单导入" },
                { value: 100, label: "中转入库计划" },
                { value: 101, label: "期初期末报表" },
                { value: 110, label: "中转出库计" },
                { value: 120, label: "库存明细" },
                { value: 121, label: "库存变动明细" },
                { value: 122, label: "库存预留" },
                { value: 123, label: "库存在途" },
                { value: 124, label: "库存快照" },
                { value: 125, label: "库存批次明细" },
                { value: 126, label: "库存批次变动明细" },
                { value: 127, label: "库存批次快照" },
                { value: 200, label: "销售出库计划单" },
                { value: 210, label: "出库执行单" },
                { value: 220, label: "其他出库单" },
                { value: 230, label: "产品回写执行单" },
                { value: 300, label: "调拨计划单" },
                { value: 310, label: "调拨出库单" },
                { value: 320, label: "调拨入库计划单" },
                { value: 330, label: "调拨入库单" },
                { value: 400, label: "销售退货单" },
                { value: 410, label: "销售退货计划单" },
                { value: 420, label: "入库计划单" },
                { value: 430, label: "入库单" },
                { value: 435, label: "其他入库单（华美入库单接口回写）" },
                { value: 440, label: "其他入库单" },
                { value: 450, label: "发运单" },
                { value: 500, label: "事务单" },
                { value: 510, label: "事务执行单" },
                { value: 700, label: "库存异动单据" },
            ]
        },
        //操作
        getActionList() {
            return [
                { value: 5, label: "导出" },
                { value: 10, label: "批量计费" },
                { value: 15, label: "FBA箱标生成中" },
                { value: 20, label: "配送费结算" },
                { value: 30, label: "创建账单" },
                { value: 40, label: "暂不处理" },
                { value: 50, label: "恢复正常" },
                { value: 60, label: "作废" },
                { value: 70, label: "导入费率" },
                { value: 80, label: "费率复制" },
                { value: 85, label: "导入" },
                { value: 95, label: "箱数据导入" },
                { value: 96, label: "FBA箱数据导入" },
                { value: 98, label: "入库计划自动装箱" },
                { value: 99, label: "删除账单" },
                { value: 105, label: "创建Label" },
                { value: 110, label: "导出账单明细" },
                { value: 120, label: "费用明细" },
                { value: 130, label: "一键装箱" },
                { value: 140, label: "生成箱标" },
                { value: 400, label: "取消单据" },
                { value: 930, label: "推送仓库" }
            ]
        },
        //状态
        getStatusList() {
            // 状态（0.已创建 10.等待中 20.处理中 30.处理成功 40.处理失败）
            return [{
                value: '0',
                label: '已创建'
            }, {
                value: '10',
                label: '等待中'
            }, {
                value: '20',
                label: '处理中'
            }, {
                value: '30',
                label: '处理成功'
            }, {
                value: '40',
                label: '处理失败'
            }]
        },
        SearchsData() {
            return [
                {
                    label: "任务编号",
                    key: 'EQ_taskNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "模块",
                    key: 'EQ_module',
                    show: true,
                    tag: 'vSelect',
                    options: this.getModuleList
                },
                {
                    label: "操作",
                    key: 'EQ_action',
                    show: true,
                    tag: 'vSelect',
                    options: this.getActionList
                },
                {
                    label: "状态",
                    key: 'EQ_status',
                    more: true,
                    tag: 'vSelect',
                    options: this.getStatusList
                },
                {
                    label: "关联单据号",
                    key: 'EQ_orderNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    more: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [{
                title: '任务编号',
                key: 'taskNo',
            }, {
                title: '模块',
                key: 'module',
                render: (h, { row }) => this.findRenderLabel(this.getModuleList, row.module),
            }, {
                title: '操作',
                key: 'action',
                render: (h, { row }) => this.findRenderLabel(this.getActionList, row.action),
            }, {
                title: '状态',
                key: 'status',
                render: (h, { row }) => this.findRenderLabel(this.getStatusList, row.status),
            }, {
                title: '关联文件',
                key: 'url',
                render: (h, { row }) => {
                    return <a v-show={row.url} class="color-link" downlaod href={row.url}>文件下载</a>
                }
            }, {
                title: '关联单据号',
                key: 'orderNo',
            }, {
                title: '异常说明',
                key: 'exception',
            }, {
                title: '处理时间',
                key: 'startAt',
                render(h, { row }) {
                    return <div>
                        开始:{row.startAt}<br />
                        结束:{row.endAt}
                    </div>
                }
            },
            {
                title: '创建人',
                key: 'createdName',
            },
            {
                title: '创建时间',
                key: 'createdAt',
            }];
        },
    },
};




